import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BottomTabNavigation from '../../components/ui/BottomTabNavigation';
import PostHeader from './components/PostHeader';
import PostMedia from './components/PostMedia';
import PostEngagement from './components/PostEngagement';
import PostCaption from './components/PostCaption';
import CommentSection from './components/CommentSection';
import RelatedPosts from './components/RelatedPosts';

const PostDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const postId = searchParams?.get('id') || '1';

  const [isFollowing, setIsFollowing] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const mockPosts = [
  {
    id: "1",
    author: "Sarah Anderson",
    username: "sarahcreates",
    authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    authorAvatarAlt: "Professional headshot of woman with long brown hair wearing white blouse smiling at camera",
    isVerified: true,
    isOwnPost: false,
    mediaType: "image",
    mediaUrl: "https://images.unsplash.com/photo-1599834778935-72ca56441e81",
    mediaAlt: "Stunning mountain landscape at sunset with golden light illuminating snow-capped peaks and valley below",
    caption: "Captured this breathtaking moment during my recent hiking trip to the Rocky Mountains. The golden hour light was absolutely magical, painting the peaks in warm hues. Nature never ceases to amaze me with its beauty and grandeur.\n\nThis was taken after a challenging 6-hour hike, but every step was worth it for this view. Remember to always respect nature and leave no trace behind.",
    hashtags: ["nature", "mountains", "photography", "hiking", "sunset", "landscape"],
    location: "Rocky Mountain National Park, Colorado",
    likes: 15847,
    comments: 342,
    timestamp: new Date(Date.now() - 7200000)?.toISOString(),
    commentsList: [
    {
      id: "c1",
      author: "Michael Chen",
      authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18142c6fb-1763296479151.png",
      authorAvatarAlt: "Professional headshot of Asian man with short black hair wearing blue shirt",
      isVerified: false,
      text: "This is absolutely stunning! The composition and lighting are perfect. What camera did you use?",
      time: "2 hours ago",
      likes: 45,
      timestamp: new Date(Date.now() - 7200000)?.toISOString(),
      replies: [
      {
        id: "c1r1",
        author: "Sarah Anderson",
        authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
        authorAvatarAlt: "Professional headshot of woman with long brown hair wearing white blouse smiling at camera",
        isVerified: true,
        text: "Thank you so much! I used a Canon EOS R5 with a 24-70mm lens. The golden hour really did most of the work though!",
        time: "1 hour ago",
        likes: 23,
        timestamp: new Date(Date.now() - 3600000)?.toISOString(),
        replies: []
      }]

    },
    {
      id: "c2",
      author: "Emma Rodriguez",
      authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a36548bd-1763296665300.png",
      authorAvatarAlt: "Professional headshot of Hispanic woman with curly dark hair wearing red top",
      isVerified: true,
      text: "I\'ve been to this exact spot! Your photo captures it so much better than mine did. The colors are incredible!",
      time: "3 hours ago",
      likes: 67,
      timestamp: new Date(Date.now() - 10800000)?.toISOString(),
      replies: []
    },
    {
      id: "c3",
      author: "David Thompson",
      authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d09386d6-1763293789598.png",
      authorAvatarAlt: "Professional headshot of Caucasian man with beard wearing gray sweater",
      isVerified: false,
      text: "Adding this to my bucket list! How difficult was the hike? I'm planning a trip there next month.",
      time: "4 hours ago",
      likes: 12,
      timestamp: new Date(Date.now() - 14400000)?.toISOString(),
      replies: [
      {
        id: "c3r1",
        author: "Sarah Anderson",
        authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
        authorAvatarAlt: "Professional headshot of woman with long brown hair wearing white blouse smiling at camera",
        isVerified: true,
        text: "It's moderately challenging! Make sure you're well-prepared with proper gear and start early. The altitude can be tough if you're not acclimated.",
        time: "3 hours ago",
        likes: 8,
        timestamp: new Date(Date.now() - 10800000)?.toISOString(),
        replies: []
      },
      {
        id: "c3r2",
        author: "James Wilson",
        authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19210013b-1763292285589.png",
        authorAvatarAlt: "Professional headshot of African American man with short hair wearing black shirt",
        isVerified: false,
        text: "I did this hike last summer. Definitely bring lots of water and snacks. The views are worth every step!",
        time: "2 hours ago",
        likes: 5,
        timestamp: new Date(Date.now() - 7200000)?.toISOString(),
        replies: []
      }]

    },
    {
      id: "c4",
      author: "Lisa Park",
      authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18a713e78-1763297858426.png",
      authorAvatarAlt: "Professional headshot of Asian woman with long black hair wearing white dress",
      isVerified: false,
      text: "The way the light hits the mountains is just perfect! This deserves to be in a gallery.",
      time: "5 hours ago",
      likes: 89,
      timestamp: new Date(Date.now() - 18000000)?.toISOString(),
      replies: []
    }]

  },
  {
    id: "2",
    author: "Sarah Anderson",
    username: "sarahcreates",
    authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    authorAvatarAlt: "Professional headshot of woman with long brown hair wearing white blouse smiling at camera",
    isVerified: true,
    isOwnPost: false,
    mediaType: "image",
    mediaUrl: "https://images.unsplash.com/photo-1710446918243-a6dd01a53112",
    mediaAlt: "Serene alpine lake reflecting mountain peaks with crystal clear turquoise water surrounded by pine forest",
    caption: "Morning reflections at the alpine lake.",
    hashtags: ["lake", "reflection", "nature"],
    location: "Alpine Lake, Colorado",
    likes: 12453,
    comments: 234,
    timestamp: new Date(Date.now() - 86400000)?.toISOString(),
    commentsList: []
  },
  {
    id: "3",
    author: "Sarah Anderson",
    username: "sarahcreates",
    authorAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    authorAvatarAlt: "Professional headshot of woman with long brown hair wearing white blouse smiling at camera",
    isVerified: true,
    isOwnPost: false,
    mediaType: "video",
    mediaUrl: "https://example.com/video.mp4",
    videoThumbnail: "https://images.unsplash.com/photo-1689453537235-879084b080fd",
    mediaAlt: "Time-lapse video of clouds moving over mountain peaks during sunset with dramatic lighting",
    caption: "Time-lapse of the sunset over the peaks.",
    hashtags: ["timelapse", "sunset", "mountains"],
    location: "Rocky Mountains, Colorado",
    likes: 18932,
    comments: 456,
    timestamp: new Date(Date.now() - 172800000)?.toISOString(),
    commentsList: []
  }];


  const currentPost = mockPosts?.find((post) => post?.id === postId) || mockPosts?.[0];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [postId]);

  const handleFollowToggle = () => {
    setIsFollowing(!isFollowing);
  };

  const handleLike = () => {
    setIsLiked(!isLiked);
  };

  const handleComment = () => {
    const commentSection = document.getElementById('comment-section');
    if (commentSection) {
      commentSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const commentInput = commentSection?.querySelector('input');
      if (commentInput) {
        setTimeout(() => commentInput?.focus(), 300);
      }
    }
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${currentPost?.author}'s post`,
        text: currentPost?.caption,
        url: window.location?.href
      })?.catch(() => {
        console.log('Share cancelled');
      });
    } else {
      navigator.clipboard?.writeText(window.location?.href);
      alert('Link copied to clipboard!');
    }
  };

  const handleSave = () => {
    setIsSaved(!isSaved);
  };

  const handleAddComment = (commentText) => {
    console.log('New comment:', commentText);
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="md:ml-20">
        <div className="max-w-4xl mx-auto">
          <PostHeader
            post={currentPost}
            onFollowToggle={handleFollowToggle}
            isFollowing={isFollowing} />


          <PostMedia post={currentPost} />

          <PostEngagement
            post={currentPost}
            onLike={handleLike}
            onComment={handleComment}
            onShare={handleShare}
            onSave={handleSave}
            isLiked={isLiked}
            isSaved={isSaved} />


          <PostCaption post={currentPost} />

          <div id="comment-section">
            <CommentSection
              comments={currentPost?.commentsList}
              onAddComment={handleAddComment} />

          </div>

          <RelatedPosts
            posts={mockPosts}
            currentPostId={currentPost?.id} />

        </div>
      </div>
      <div className="pb-16 md:pb-0">
        <BottomTabNavigation />
      </div>
    </div>);

};

export default PostDetails;